import React from 'react';
import styles from './GeometricBackground.module.css';

const GeometricBackground: React.FC = () => {
  const shapes = Array(100).fill(null); // Increased number of shapes

  return (
    <div className={styles.geometricBackground}>
      {shapes.map((_, index) => (
        <div
          key={index}
          className={`${styles.shape} ${styles[`shape${index % 10}`]}`} // Increased shape variety
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 10}s`,
            animationDuration: `${20 + Math.random() * 40}s`, // More varied animation duration
            transform: `scale(${0.5 + Math.random() * 0.8})`, // Random scaling
          }}
        />
      ))}
    </div>
  );
};

export default GeometricBackground;